export default "__VITE_ASSET__DdKfJtjd__"